export const USER_CREATED_MESSAGE = 'User created successfully.';
export const LOGIN_SUCCESS_MESSAGE = 'Login successful. Welcome back!';
export const REPORT_SAVE_SUCCESS_MESSAGE = 'Report saved successfully.';
export const REPORT_PUBLISHED_MESSAGE = 'Report published successfully.';
export const PROFILE_UPDATE_SUCCESS_MESSAGE = 'Profile updated successfully.';
export const REPORTS_PER_PAGE = 6;
